module.exports = __webpack_public_path__ + "static/img/banner-2.c49acfc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/banner-2.png
// module id = mReB
// module chunks = 0